import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fleet-dashboard',
  templateUrl: './fleet-dashboard.component.html',
  styleUrls: ['./fleet-dashboard.component.scss']
})
export class FleetDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  public pieData: any = [
    { category: 'Fuel', value: 20 },
    { category: 'Mechanic', value: 28 },
    { category: 'Service', value: 22 },
    { category: 'Insurance', value: 40 }
  ]

}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/fleet-management/fleet-dashboard/fleet-dashboard.component.ts